module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title-billing-address":"Rechnungsadresse","not-recorded-yet":"Noch nicht erfasst","not-recorded":"nicht erfasst"},"fr":{"not-recorded":"pas saisi","not-recorded-yet":"Pas encore saisi","title-billing-address":"Adresse de facturation"},"it":{"not-recorded":"non registrato","not-recorded-yet":"Non ancora registrato","title-billing-address":"Indirizzo di fatturazione"}}')
  delete Component.options._Ctor
}
